import React, { memo } from "react";
import { useTranslation } from "react-i18next";

const SidebarLoadingState: React.FC = memo(() => {
  const { t } = useTranslation();
  
  return (
    <div className="loading-state">
      <div className="loading-spinner"></div>
      <p>{t("common.loading")}</p>
    </div>
  );
});

SidebarLoadingState.displayName = "SidebarLoadingState";

export default SidebarLoadingState;
